import { render, staticRenderFns } from "./uf_month_return.vue?vue&type=template&id=25e91164&scoped=true"
import script from "./uf_month_return.vue?vue&type=script&lang=js"
export * from "./uf_month_return.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25e91164",
  null
  
)

export default component.exports